import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import type { InputProps } from 'antd';
import { Input } from 'antd';
import styled, { css } from 'styled-components';

const DEFAULT_STYLING = css`
    padding: 10px 16px;
    ${FONT_FAMILY.poppins};
`;

const StyledInput = styled((props: InputProps) => <Input {...props} />)`
    .ant-input,
    &.ant-input,
    &.ant-input-affix-wrapper {
        border: 1px solid ${BC.default};
        border-radius: 8px;
        color: ${TC.filled};
        ${DEFAULT_STYLING}
    }

    &::placeholder,
    ::placeholder {
        color: ${TC.body};
    }

    &:hover {
        border-color: ${BC.hover};
        background: ${({ value }) => (value ? SC.page : SC.white)};
    }

    &:focus,
    &:focus-within,
    &.ant-input-focused {
        border-color: ${BC.focus};
    }

    &[disabled] {
        background-color: ${SC.neutral};
        color: ${TC.disabled};
        border-color: ${BC.disabled};
        cursor: not-allowed;
    }

    &.ant-input-status-error {
        border: 2px solid ${BC.error} !important;
        background: ${({ value }) => (value ? SC.error : SC.white)} !important;
    }

    &.success {
        border: 2px solid ${BC.success};
        background: ${({ value }) => (value ? SC.success : SC.white)};

        span[role='img'] {
            color: ${BC.success};
        }
    }
`;

export const InputLabel = styled.div`
    ${DESKTOP_SIZES[SIZES.HEADING_XXXS].fontSize}
    ${DESKTOP_SIZES[SIZES.HEADING_XXXS].fontWeight}
    margin-bottom: 8px;
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    color: ${TC.heading};
    text-align: left;
    ${FONT_FAMILY.poppins};
`;

export const InputWrapper = styled.div`
    margin-bottom: 24px;
    user-select: none;

    &#password-input {
        margin-bottom: 40px;
    }
`;

export const SwitchMainWrapper = styled.div`
    margin-bottom: 24px;
    align-self: center;
`;

export const HintText = styled.div<{ $showByDefault?: boolean }>`
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    color: ${TC.body};
    visibility: ${({ $showByDefault = true }) => ($showByDefault ? 'visible' : 'hidden')};

    &.has-error {
        color: ${TC.error};
    }
`;

export default StyledInput;
